<template>
    <div>
        <!-- Boton para poder seleccionar de nuevo alguna de las cotizaciones -->
        <section class="bg-gray2 max-w-4xl pt-5 pl-5 pb-2 mx-auto my-0" v-if="showCuotations">
            <a class="cursor-pointer pb-2" v-if="quotationSelected" @click="reset()">
                <i
                    class="border-solid border-black inline-block p-1 mr-1"
                    style="border-width: 0 2px 2px 0; transform: rotate(135deg)"
                ></i>
                <p class="inline-block text-sm pb-2">Regresar</p>
            </a>

            <p class="font-medium text-xl lg:text-2xl">PASO 2</p>
            <!-- SECCION PARA MOSTRAR EL RESULTADO DE LA COTIZACIÓN DE BBV -->
            <div
                :class="{
                    'text-center  lg:grid lg:grid-cols-2 md:grid md:grid-cols-2 sm:mx-auto pt-2': showBBVA,
                    'text-center pt-4 sm:mx-auto mx-auto': !showBBVA,
                }"
                v-if="showFormSection"
            >
                <div class="flex flex-col">
                    <span
                        :class="{
                            'text-xl font-bold text-center pb-4': showBBVA,
                            ' text-xl font-bold text-center pb-4 hidden': !showBBVA,
                        }"
                        >Financiamiento</span
                    >
                    <p
                        :class="{
                            'text-center font-bold pb-2': showBBVA,
                            'text-center font-bold pb-2 hidden': !showBBVA,
                        }"
                    >
                        BBVA Consumer Finance
                    </p>
                    <!-- <p class="text-center font-bold pb-2"> BBVA Consumer Finance</p> -->
                    <button
                        style="height: auto"
                        v-if="showBBVA"
                        @click="quotationChoose('bbva')"
                        id="BBVA"
                        class="mx-5 text-center h-full shadow-xl hover:shadow-xl border-b-8 border-gray2 cursor-pointer quotation-select"
                    >
                        <div class="pl-5 py-2 px-1 bg-white mb-2 card-item-first">
                            <p class="pb-2">
                                Tasa de interés fija del
                                <span class="font-bold">{{ tasa }}%</span>
                                anual.
                            </p>
                            <p class="pb-2">
                                Pago mensual:
                                <span class="font-bold">${{ formatPrice(pagoMensual) }}</span>
                                <br />
                                <span class="text-xs">El pago mensual no incluye IVA ni comisiones .</span>
                            </p>
                            <p class="pb-2">
                                CAT <span class="font-bol">{{ cat }}</span> Sin IVA Informativo.
                            </p>
                            <span class="text-xs"
                                >Consulta términos, condiciones y requisitos de contratación del crédito automotriz
                                Consumer Finance en
                                <a
                                    class="underline"
                                    href="https://www.bbva.mx/personas/productos/creditos/credito-auto.html"
                                    target="_blank"
                                    >BBVA.mx</a
                                ></span
                            >
                        </div>
                        <div class="pl-5 px-1 bg-white card-item-two">
                            <p class="pb-2">
                                Financiamiento:
                                <span class="font-bold">${{ formatPrice(financiamiento) }}</span>
                            </p>
                            <span>Total a pagar ${{ formatPrice(totalAPagar) }}</span>
                        </div>
                    </button>
                </div>

                <!-- SECCION PARA MOSTRAR EL RESULTADO DE LA COTIZACIÓN DE ABC -->
                <div
                    :class="{
                        'flex flex-col': showBBVA,
                        'flex flex-col items-center justify-center': !showBBVA,
                    }"
                >
                    <span class="text-xl font-bold text-center pb-4">Arrendamiento</span>
                    <p class="text-center font-bold pb-2">FinBe ABC Finance</p>
                    <button
                        style="height: auto"
                        v-if="showABC"
                        @click="quotationChoose('abc')"
                        id="ABC"
                        :class="{
                            'mx-5 text-center   shadow-xl hover:shadow-xl  border-b-8 border-gray2  cursor-pointer  quotation-select':
                                showBBVA,
                            'mx-5 text-center   shadow-xl hover:shadow-xl  border-b-8 border-dark-blue  cursor-pointer  quotation-select w-1/2':
                                !showBBVA,
                        }"
                    >
                        <div class="pl-5 py-2 px-1 bg-white mb-2 card-item-first">
                            <p>
                                {{ months }} pagos de:
                                <span class="font-bold">${{ formatPrice(monthlyPayment) }}</span>
                            </p>
                            <p class="text-xs">No incluye IVA</p>
                            <p v-if="maxDownPayment > 0" class="pb-2 underline font-bold text-sm">
                                Enganche maximo 35% :
                                <span class="font-bold">${{ formatPrice(maxDownPayment) }}</span>
                            </p>
                            <p>
                                <span class="pb-2">Pago inicial: ${{ formatPrice(initialPayment) }}</span>
                            </p>
                            <p>
                                <span class="pb-2">Monto financiado: ${{ formatPrice(financedAmount) }}</span>
                            </p>
                        </div>
                        <div class="pl-5 px-1 bg-white card-item-two">
                            <p class="pb-2">
                                Comisión por apertura:
                                <span class="font-bold">${{ formatPrice(abcQuotation.Commission) }}</span>
                            </p>
                            <p class="pb-2">
                                <span>Anticipo ${{ formatPrice(initialDownPayment) }}</span>
                            </p>
                            <p class="pb-2">
                                Valor residual:
                                <span class="font-bold">${{ formatPrice(abcQuotation.ResidualValue) }}</span>
                            </p>
                        </div>
                        <!-- <div class="bg-blue-400 w-auto h-3">
               </div> -->
           </button>
       </div>


       </div>
       <!-- Botón para ocultar o mostrar una aseguradora dependiendo de cual se selecciono -->
       <div class="text-center pt-5">
        <button v-if="showButtonNext" 
        class="w-full sm:w-40 text-center bg-dark-blue text-white text-sm py-2 mx-auto "
        @click="nextStep()"
        > Siguiente</button>

       </div>

 
    </section>

    <!-- Componente para mostrar las aseguradoras de ABC -->
    <div class="pt-2" v-if="dataInsurer && ShowAbcInsurer">
        <abc-insurance-selection
        :insurersTotal="insurersTotal"
        :insurersComplete="insurersComplete"
        :months="months"
        :subsidiaryInfo=subsidiaryWebpage
        :model="model"
        :version="version"
        :modelYear="modelYear"
        :is-iframe="isIframe"
        :downpayment="downpayment"
        :monthlyPayment="formatPrice(monthlyPayment)"
        :inte-color="inteColor"
        :ext-color="extColor"
        :image="image"
        @showForms="showForms"
        @downLoadPdf="downLoadPdf"
        :total-to-pay="AbcFinance"
        :financing="financedAmount"
        >
        </abc-insurance-selection>

    </div>
    <!-- Seccion para mostrar un loader mientras cargan las aseguradoras  -->
    <div v-else>
        <div v-if="ShowAbcInsurer"  class="p-4 md:p-6 shadow bg-gray2 max-w-4xl text-center container my-0">
            <span  class="text-center">
                Cargando aseguradoras...
                <spinner-loader
                    class="mt-8"
                    :progress="seconds"
                />
            </span>  
        </div>
    </div>

        <!-- Persons form and send data -->
    <abc-register v-if="showPersons" :abcQuotationData="abcQuotationData" @sendchannel="sendchannel">
    </abc-register>

        <!-- Response after the email was sended -->
    <div class="text-center text-lg bg-gray2 font-bold pt-4 pb-4 mx-2" v-if="showResponse">
        Tu registro ha sido guardado de manera exitosa, recuerda consultar tu correo electrónico para el seguimiento de tu solicitud.
        <a
        class="w-20 xs:w-68 sm:w-88 hyundai-button sm:text-base mx-auto my-3 mb-8"            
        :href="`${url}/${webpage}/modelos`"
        >
            Consultar otros modelos</a
        >
    </div>
    </div>
</template>

<script>
import AbcRegister from "../Abc/AbcRegister.vue";
import { jsPDF } from "jspdf";
import moment from "moment";

export default {
    components: { AbcRegister },

    props: [
        "bbvaQuotation",
        "abcQuotation",
        "downpayment",
        "maxDownPayment",
        "rangeInstalment",
        "versionPrice",
        "modelYear",
        "abcQuotationData",
        "subsidiary",
        "subsidiaryWebpage",
        "hyundaiKeyQ",
        "model",
        "version",
        "isIframe",
        "inteColor",
        "extColor",
        "image"
    ],

    data() {
        return {
            url: $(".url").text(),
            // Variable para almacenar el slug del distribuidor
            webpage: $(".webpage").text(),
            showCuotations: true,
            ShowAbcInsurer: false,
            quotation: "",
            dataInsurer: false,
            insurersTotal: [],
            insurersComplete: [],
            insurer: 0,
            showPersons: false,
            showFormSection: true,
            formComplete: false,
            showButtonNext: false,
            showButton: false,
            isActive: false,
            isActive2: false,
            showBBVA: true,
            showABC: true,
            seconds: 0,
            showResponse: false,
            tasa: 0,
            pagoMensual: 0,
            cat: 0,
            financiamiento: 0,
            totalAPagar: 0,
            firstPayment: 0,
            showLoader: false,
            dealerInfo: "",
            quotationSelected: false,
            // Variable para almacenar la url para descargar el PDF
            urlPDF: "",
            // Variable para almacenar una instancia de JsPDF para
            // generar el pdf de la tabla de amortización
            docPdf: "",
            //almacenamos la cotizacion de abc
        };
    },
    created() {
        this.getDealerInfo();
        this.getInsurers();
        console.log("QUOTATIONS PRICE", this.versionPrice);
    },
    computed: {
        //Price of  Monthly payments for ABC
        monthlyPayment() {
            return this.abcQuotation.Rent;
        },

        //Months choosed for abc if they are higher to 60 this value is adjusted to the max monthly quotation
        months() {
            return this.abcQuotation.months > 60 ? 60 : this.abcQuotation.months;
        },

        // Value of the finance of abc
        AbcFinance() {
            return this.monthlyPayment * this.months + this.abcQuotation.ResidualValue + this.insurer;
        },

        //Calculate if exist a maximium down payment and adjust it  for the initial payment
        initialPayment() {
            if (this.maxDownPayment > 0) {
                return this.abcQuotation.Commission + this.maxDownPayment + this.firstPayment;
            }
            return this.abcQuotation.Commission + this.downpayment + +this.firstPayment;
        },
        initialDownPayment() {
            if (this.maxDownPayment > 0) {
                return this.maxDownPayment;
            }
            return this.downpayment;
        },
        financedAmount() {
            const test = {
                versionPrice: this.versionPrice,
                insurer: parseInt(this.insurer),
                initialDownPayment: parseInt(this.initialDownPayment),
            };
            console.log(test);
            return parseInt(this.versionPrice) + parseInt(this.insurer) - parseInt(this.initialDownPayment);
        },
    },
    mounted() {
        console.log("Tipo de dato ", typeof this.versionPrice);
        //Listener to emit the selection of insurer in the abc quotation
        this.$eventBus.$on("insurerSelected", (val, insurerYearCost) => {
            this.insurer = parseFloat(val);
            this.firstPayment = parseFloat(insurerYearCost);
        });
        this.showBBVA = false;
        //Verify if the bbvaQuotation exist and assing the values
        let rangeSelected = parseInt(this.rangeInstalment/12) - 1
    if( this.bbvaQuotation['noInsu'][rangeSelected] != undefined){
        this.tasa =this.bbvaQuotation['noInsu'][rangeSelected].rates[0].unit.percentage
        this.pagoMensual =this.bbvaQuotation['noInsu'][rangeSelected].installmentPlan.installmentAmount.amount
        this.cat =this.bbvaQuotation['noInsu'][rangeSelected].rates[1].unit.percentage
        this.financiamiento = this.bbvaQuotation['noInsu'][rangeSelected].requestedAmount.amount
        this.totalAPagar = this.bbvaQuotation['noInsu'][rangeSelected].totalAmount.amount 
        this.showBBVA=true
    }



    },

    methods: {
        showForms() {
            this.showPersons = true;
            this.dataInsurer = false;
            this.ShowAbcInsurer = false;
            this.showCuotations = false;
        },

        countDownTimer() {
            if (this.seconds < 95) {
                setTimeout(() => {
                    this.seconds += 3;
                    this.countDownTimer();
                }, 1000);
            }
        },
        reset(){
            this.quotationSelected=false
            if (this.bbvaQuotation.insu.length > 0 || this.bbvaQuotation.noInsu.length > 0) {
                this.showBBVA= true
            }
            this.showABC= true
            this.ShowAbcInsurer=false
            this.showPersons=false

        },

        quotationChoose(value) {
            this.showButtonNext = !this.true;
            this.quotation = value;

            if (value === "abc") {
                const el = document.getElementById(`ABC`);
                el.classList.remove("border-gray2");
                el.classList.add("border-dark-blue");

                if (this.showBBVA) {
                    const el2 = document.getElementById(`BBVA`);
                    el2.classList.remove("border-dark-blue");
                    el2.classList.add("border-gray2");
                }
                this.countDownTimer();
            } else if (this.showBBVA) {
                const el = document.getElementById(`BBVA`);
                el.classList.remove("border-gray2");
                el.classList.add("border-dark-blue");

                if (this.showABC) {
                    const el2 = document.getElementById(`ABC`);
                    el2.classList.remove("border-dark-blue");
                    el2.classList.add("border-gray2");
                }
            }
        },
        showSection() {
            this.showFormSection = !this.showFormSection;
        },

        //Metodo para obtener las aseguradas del vehiculo
        getInsurers(){
            if(!this.dataInsurer){
                axios.get(`${this.url}/abc/insurer/${this.rangeInstalment}/${this.versionPrice}/${this.modelYear}/${this.hyundaiKeyQ}`)

            .then((res)=>{
            //Asignación de los 2 tipos de aseuradoras
                this.insurersTotal= res.data.total
                this.insurersComplete= res.data.complete
              
              //  this.insurers = [... new Set(res.data.data)]
               this.dataInsurer = true
            })
            .catch((error)=>{
                 console.log(error)
                 
            })
            }   
        },

        // Función para formatear el precio
        formatPrice(price) {
            return parseInt(price)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, "$&,");
        },

        //Boton para mostrar el boton para el siguiente paso de acuerdo a la cotización seleccionada
        nextStep() {
            this.quotationSelected = true;
            this.ShowAbcInsurer = false;
            this.showButtonNext = false;
            if (this.quotation === "abc") {
                this.showBBVA = false;
                this.ShowAbcInsurer = true;
            } else {
                this.$emit("showBBVAQuotationFrame");
            }
        },

        //Metodo para enviar la solicitud de digital Channel
        sendchannel() {
            this.showResponse = true;
            this.showPersons = false;
        },

        //Metodo para descargar la tabla de amortizaciones de ABC
        getDealerInfo() {
            console.log(this.subsidiary);
            console.log(typeof this.subsidiary);

            axios
                .get(`/abc/dealerInfoByCaption/${this.subsidiary}`)
                .then((res) => {
                    this.dealerInfo = res.data;
                })
                .catch();
        },

        downLoadPdf() {
            this.docPdf = new jsPDF({
                format: "letter",
            });

            let pageWidth = this.docPdf.internal.pageSize.getWidth();

            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFontSize(16);
            this.docPdf.text("HYUNDAI FINANCE", 10, 20);
            this.docPdf.setFontSize(13);
            this.docPdf.text("Cotización de Arrendamiento", 136, 23);
            this.docPdf.setFontSize(9);
            this.docPdf.text("Folio: HYUNDAI2023216317037", 149, 26);
            //ACTUALIZAR FECHA
            this.docPdf.setFontSize(8);
            this.docPdf.text(`Mérida, Yucatán a ${moment().format("DD/MM/YYYY")}`, 157, 30);

            //ACTUALIZAR FOLIO
            this.docPdf.setFontSize(8);
            this.docPdf.text("Folio del seguro: 42584751", 10, 30);

            this.docPdf.setFontSize(8);
            this.docPdf.text("Nombre del proovedor: " + this.dealerInfo.sub_name, 10, 40);
            this.docPdf.setFontSize(8);
            this.docPdf.text("Telefono: " + this.dealerInfo.sub_phones, 10, 44);
            this.docPdf.setFontSize(8);
            this.docPdf.text("Dirección: " + this.dealerInfo.sub_address, 10, 48);

            //NEW SECTION
            this.docPdf.setTextColor(20, 62, 158);
            this.docPdf.setFontSize(10);
            this.docPdf.setFont(undefined, "bold").text("Conceptos Financiados incluye IVA", 10, 60);
            this.docPdf.setFont(undefined, "bold").text(`${this.months} Meses`, 100, 60);
            this.docPdf.setFillColor(20, 62, 158);
            this.docPdf.rect(10, 61, 200, 1, "F");

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 64, 200, 6, "F");
            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFontSize(8);
            this.docPdf.setFont(undefined, "normal").text("Valor de la Unidad", 12, 68);
            this.docPdf.text(`$${this.formatPrice(this.versionPrice)}`, 100, 68);

            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 70, 200, 6, "F");
            this.docPdf.text("Seguro Financiado", 12, 75);
            this.docPdf.text(`$${this.formatPrice(this.insurer)}`, 100, 75);

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 76, 200, 6, "F");
            this.docPdf.text("(-menos) Anticipo", 12, 80);
            this.docPdf.text(`$${this.formatPrice(this.initialDownPayment * 1.16)}`, 100, 80);
            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 82, 200, 6, "F");
            this.docPdf.setFont(undefined, "bold").text("Monto Total Financiado", 12, 86);
            this.docPdf.text(`$${this.formatPrice(this.financedAmount)}`, 100, 86);
            // END SECTION

            //NEW SECTION
            this.docPdf.setTextColor(20, 62, 158);
            this.docPdf.setFontSize(10);
            this.docPdf.setFont(undefined, "bold").text("Pago Inicial", 10, 95);
            this.docPdf.setFillColor(20, 62, 158);
            this.docPdf.rect(10, 96, 200, 1, "F");

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 98, 200, 6, "F");
            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFontSize(8);
            this.docPdf.setFont(undefined, "normal").text("Anticipo", 12, 102);
            this.docPdf.text(`$${this.formatPrice(this.initialDownPayment)}`, 100, 102);
            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 104, 200, 6, "F");
            this.docPdf.text("Seguro primer año", 12, 107);
            this.docPdf.text("Financiado", 100, 107);

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 110, 200, 6, "F");
            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFontSize(8);
            this.docPdf.setFont(undefined, "normal").text("Comisión por apertura", 12, 113);
            this.docPdf.text(`$${this.formatPrice(this.abcQuotation.Commission)}`, 100, 113);
            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 116, 200, 6, "F");
            this.docPdf.text("Subtotal Pago inicial", 12, 119);
            this.docPdf.text(`$${this.formatPrice(this.abcQuotation.Commission + this.initialDownPayment)}`, 100, 119);

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 122, 200, 6, "F");
            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFontSize(8);
            this.docPdf.setFont(undefined, "normal").text("Impuesto al Valor Agregado", 12, 125);
            this.docPdf.text(
                `$${this.formatPrice(parseFloat((this.abcQuotation.Commission + this.initialDownPayment) * 0.16))}`,
                100,
                125
            );
            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 128, 200, 6, "F");
            this.docPdf.setFont(undefined, "bold").text("Total Pago Inicial", 12, 131);
            this.docPdf.text(
                `$${this.formatPrice(
                    parseFloat((this.abcQuotation.Commission + this.initialDownPayment) * 0.16) +
                        parseFloat(this.abcQuotation.Commission + this.initialDownPayment)
                )}`,
                100,
                131
            );

            // END SECTION

            //NEW SECTION
            this.docPdf.setTextColor(20, 62, 158);
            this.docPdf.setFontSize(10);
            this.docPdf.setFont(undefined, "bold").text("Renta Mensual (no incluye IVA)", 10, 140);
            this.docPdf.setFillColor(20, 62, 158);
            this.docPdf.rect(10, 141, 200, 1, "F");

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 142, 200, 6, "F");
            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFontSize(8);
            this.docPdf.setFont(undefined, "normal").text("Renta básica", 12, 146);
            this.docPdf.text(`$${this.formatPrice(this.monthlyPayment)}`, 100, 146);

            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 148, 200, 6, "F");
            this.docPdf.text("Gastos administración", 12, 153);
            this.docPdf.text(`$${this.formatPrice(parseFloat(this.monthlyPayment * 0.1))}`, 100, 153);

            this.docPdf.setFillColor(236, 223, 220);
            this.docPdf.rect(10, 154, 200, 6, "F");
            this.docPdf.text("Pago por seguro", 12, 158);
            console.log("Pago por seguro", {
                insurer: this.insurer,
                firstPayment: this.firstPayment,
                months: this.months,
            });
            this.docPdf.text(`$${this.formatPrice((this.insurer - this.firstPayment) / this.months)}`, 100, 158);
            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 160, 200, 6, "F");
            this.docPdf.setFont(undefined, "bold").text("Total Pago Mensual", 12, 164);
            this.docPdf.text(
                `$${this.formatPrice(
                    parseFloat(
                        this.monthlyPayment +
                            parseFloat(this.monthlyPayment * 0.1) +
                            parseFloat(this.insurer - this.firstPayment) / this.months
                    )
                )}`,
                100,
                164
            );
            // END SECTION

            //NEW SECTION
            this.docPdf.setTextColor(20, 62, 158);
            this.docPdf.setFontSize(10);
            this.docPdf.setFont(undefined, "bold").text("Valor Residual (no incluye IVA)", 10, 173);
            this.docPdf.setFillColor(20, 62, 158);
            this.docPdf.rect(10, 174, 200, 1, "F");

            this.docPdf.setFillColor(249, 242, 240);
            this.docPdf.rect(10, 176, 200, 6, "F");
            this.docPdf.setTextColor(0, 0, 0);
            this.docPdf.setFont(undefined, "bold").text("Valor Residual", 12, 180);
            this.docPdf.text(`$${this.formatPrice(this.abcQuotation.ResidualValue)}`, 100, 180);

            // END SECTION
            this.docPdf.rect(95, 55, 30, 133);

            this.docPdf.setFillColor(51, 64, 71);
            this.docPdf.rect(0, 220, 300, 100, "F");
            this.docPdf.setTextColor(255, 255, 255);
            this.docPdf
                .setFont(undefined, "normal")
                .setFontSize(6)
                .text(`1. La presente cotización estará vigente hasta el ${moment().format("DD/MM/YYYY")}`, 15, 226);
            this.docPdf.text(
                "2. El pago inicial no incluye impuestos locales como tenencia, costo de placas y gastos de gestoría, los importes originados por estos conceptos serán cargados",
                15,
                229
            );
            this.docPdf.text(
                "a la cuenta domiciliada una vez que se hayan realizado los trámites correspondientes.",
                15,
                231
            );
            this.docPdf.text(
                "3. Recuerde que, en automóviles utilitarios el límite de deducibilidad mensual establecido por la Ley de Impuesto Sobre la Renta es de $6,000.00 mensuales",
                15,
                234
            );
            this.docPdf.text(
                "(sin incluir IVA ni gastos de arrendamiento). Este límite no aplica para vehículos de trabajo tales como pickups y camiones de carga ligera.",
                15,
                236
            );
            this.docPdf.text(
                "4. Cualquier cambio respecto a las condiciones establecidas dentro del proceso de aprobación de crédito correspondiente invalida la presente propuesta, misma que",
                15,
                239
            );
            this.docPdf.text("únicamente será posible ejercer durante su vigencia.", 15, 241);
            this.docPdf.text(
                "5. Nota importante: Bajo la opción de pago de la prima de seguro anual de contado, es posible que las anualidades siguientes puedan sufrir incrementos,",
                15,
                244
            );
            this.docPdf.text(
                "dependiendo de la siniestralidad del vehículo o por cambios en las políticas de precio de la aseguradora, por lo que bajo esta modalidad se acepta",
                15,
                246
            );
            this.docPdf.text(
                "6. El límite de kilometraje es de manera anual, si el usuario excede la cantidad de kilómetros establecidos, no existirá ningún costo siempre y cuando",
                15,
                250
            );
            this.docPdf.text("se pague el valor residual, de lo contrario cada KM extra tendrá un costo.", 15, 252);
            this.docPdf.text(
                "7. Esta cotización está sujeta a cambios sin previo aviso hasta la aceptación y firma del contrato.",
                15,
                256
            );

            this.docPdf.text("Calle 56-B No. 452 x 11 y 13", 10, 265);
            this.docPdf.text("Colonia Itzimná", 10, 268);
            this.docPdf.text("Mérida, Yucatán C.P. 97100", 10, 271);
            this.docPdf.text("(999) 940 6778, (999) 940 6779", 10, 274);

            this.docPdf.save("Cotizacion Finbe ABC.pdf");
        },
    },
};
</script>

<style>
.card-item-first {
    padding-left: 1.25rem;
    min-height: 12rem;
    padding-top: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.card-item-two {
    min-height: 9rem;
    padding: 1.3rem 0;
}
</style>
